import {inject, Injectable, signal} from "@angular/core";
import {EventEmitterService} from "@event-emitter";
import {TypePredicates, SimDeviceService} from "@services";
import {ApplicationData, DeviceActivityType} from "@models";

@Injectable()
export class DisplayStateService<T extends ApplicationData = ApplicationData> {
	// Signals
	public applicationData = signal<T | null>(null);
	public isLoading = signal<boolean>(true);

	// Injections
	private _eventEmitter = inject(EventEmitterService);
	private _simDeviceService = inject(SimDeviceService);

	public async initialize() {
		this._eventEmitter.onApplicationDataChanged.subscribe(({applicationData}) => {
			const currentData = this.applicationData();

			if (
				currentData &&
				TypePredicates.isRoomStateScreenApplicationData(currentData) !==
					TypePredicates.isRoomStateScreenApplicationData(applicationData)
			) {
				// Skip update if types don't match
				return;
			}

			this.applicationData.set(applicationData as T);
			this.isLoading.set(false);
		});

		await this._simDeviceService.readyToCommunicate(DeviceActivityType.Display).then();
	}
}
